import React, { FC } from 'react'

import { Messages } from 'modules/Messages/components'
import { useMessages } from 'modules/Messages/serviceHooks'
import { ConditionRender } from 'components'
import { isEmpty } from 'shared/utils/isEmpty'

const MessagesContainer: FC = () => {
  const { message, updateInfoMessage, updateInfoMessageLoading } = useMessages()

  return (
    <ConditionRender
      condition={!isEmpty(message)}
      component={
        <Messages
          messageData={message}
          updateInfoMessage={updateInfoMessage}
          messageLoading={updateInfoMessageLoading}
        />
      }
    />
  )
}

export default MessagesContainer
